<div class="range-slider range-slider--{{ color }}">
  @if (label) {
    <app-input-title>
      {{ label }}
    </app-input-title>
  }
  <div class="range-slider__main" [ngClass]="{ 'range-slider__main--disabled': disabled }">
    <div #rangeSlider class="range-slider__slide" [ngClass]="{ 'range-slider__slide--dragging': draged, 'range-slider__slide--animated': animate }" (mousedown)="mousedown($event)" (mouseup)="mouseup($event)" (click)="click($event)">
      <div class="range-slider__progress">
        <div class="range-slider__progress-active" [ngStyle]="{ left: 'calc(' + position[0] + '%)', 'right.%': 100 - position[1] }"></div>
      </div>
      @if (!disabledFrom) {
        <div class="range-slider__dot" [ngStyle]="{ 'left.%': position[0] }" (panstart)="dragStart('min', $event)" (pan)="dragging('min', $event)" (panend)="dragEnd()"></div>
      }
      @if (!disabledTo) {
        <div class="range-slider__dot" [ngStyle]="{ 'left.%': position[1] }" (panstart)="dragStart('max', $event)" (pan)="dragging('max', $event)" (panend)="dragEnd()"></div>
      }
    </div>
    @if (stepsLabel && steps) {
      <div class="range-slider__labels range-slider__labels--steps range-slider__labels--{{ labelSize }}" style="--range-slider-steps: {{ steps.length }}">
        @for (step of steps; track $index) {
          <span class="range-slider__labels-item" [ngClass]="{ 'range-slider__labels-item--active': value[1] === step }">{{ step }}{{ unit }}</span>
        }
      </div>
    } @else if (minLabel !== undefined && maxLabel !== undefined) {
      <div class="range-slider__labels range-slider__labels--{{ labelSize }}">
        <span class="range-slider__labels-item">{{ minLabel }}{{ unit }}</span>
        <span class="range-slider__labels-item">{{ maxLabel }}{{ unit }}</span>
      </div>
    }
  </div>
</div>
